import {ChangeDetectionStrategy, Component, input, computed} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UmpireComponentVideo} from '@tisa-group/models';

@Component({
  selector: 'tisa-video-client',
  imports: [CommonModule],
  templateUrl: './video-client.component.html',
  styleUrl: './video-client.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoClientComponent {
  readonly component = input<UmpireComponentVideo | undefined>();

  readonly videoUrl = computed(() => {
    const video = this.component()?.video;
    if (!video) return null;

    // Handle both 'url' and 'external_url' properties
    return (video as any).external_url || (video as any).url || null;
  });
}
